import { useTour } from '@reactour/tour'
import { useCallback } from 'react'

import { StepContainer } from 'lib/tour'

export const steps = [
  {
    selector: '.page-view-area',
    content: (
      <StepContainer>
        <p>
          Welcome to the cover editor. Here you can create a unique cover for
          your book.
        </p>
      </StepContainer>
    ),
  },
  {
    selector: '.canvas-wrapper',
    content: (
      <StepContainer>
        <p>
          While you are working on your cover, please be aware that important
          content should be placed within the inner border.
        </p>
        <p>
          Images and other content that you want to reach to the edge of the
          page should run all the way to the edge of the outer border.
        </p>
        <p>
          Following these rules will ensure that you get a great quality print.
        </p>
      </StepContainer>
    ),
  },
  {
    selector: '.add-element-tools',
    content: (
      <StepContainer>
        <p>
          Here you have options to add text, images, and geometric shapes to
          your cover.
        </p>
      </StepContainer>
    ),
  },
  {
    selector: '.cover-section-tabs',
    content: (
      <StepContainer>
        <p>
          Click on these tabs to switch between editing the front cover, spine,
          and back cover.
        </p>
      </StepContainer>
    ),
  },
  {
    selector: '.file-nav',
    content: (
      <StepContainer className="canvas-wrapper">
        <p>Here you have options like saving or previewing your cover.</p>
      </StepContainer>
    ),
  },
  {
    selector: '.undo-redo-btns',
    content: (
      <StepContainer className="canvas-wrapper">
        <p>These buttons allow you to undo and redo changes.</p>
      </StepContainer>
    ),
  },
  {
    selector: '.background-controls',
    content: (
      <StepContainer className="canvas-wrapper">
        <p>Here you can set a background pattern or image.</p>
      </StepContainer>
    ),
  },
  {
    selector: '.ft-right',
    content: (
      <StepContainer className="canvas-wrapper">
        <p>These tools allow you to zoom in and pan around the canvas.</p>
        <p>
          When you select an object, an additional menu will be shown allowing
          you to move objects to the foreground or background, as well as other
          contextual options.
        </p>
      </StepContainer>
    ),
  },
  {
    selector: '.approve-btn',
    content: (
      <StepContainer className="canvas-wrapper">
        <p>
          When you are done, click on the check mark button here: Your cover is
          ready to print!
        </p>
      </StepContainer>
    ),
  },
]

export const useCoverEditorTour = () => {
  const { setIsOpen, setSteps, setCurrentStep } = useTour()

  return useCallback(() => {
    setSteps(steps)
    setCurrentStep(0)
    setIsOpen(true)
  }, [setCurrentStep, setIsOpen, setSteps])
}
